module.exports = __webpack_public_path__ + "img/inu_gallery18.9d7061ca.jpg";